import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoujjaindarshanbusonrent() {



  const cardData =
  {
    keyword: 'Pune to Ujjain Darshan Bus On Rent',
    heading: 'Sanavi Travels: Pune to Ujjain Darshan Bus On Rent',
    headingDescription: 'Sanavi Travels offers reliable Pune to Ujjain Darshan Bus on Rent, providing safe, comfortable, and well-organized transportation for pilgrims, families, and groups traveling from Pune to the sacred city of Ujjain. Our fleet of well-maintained AC and non-AC buses ensures spacious seating, smooth rides, and a peaceful long-distance travel experience. With experienced drivers, flexible one-way and round-trip darshan packages, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, dependable, and stress-free pilgrimage travel. We provide convenient pickup services across Pune including Hinjewadi, Baner, Wakad, Kothrud, Hadapsar, Pimpri-Chinchwad, Swargate, and Pune Railway Station, covering major religious sites such as Mahakaleshwar Jyotirlinga, Kal Bhairav Temple, Harsiddhi Mata Temple, and Ram Ghat. Choose Sanavi Travels for trusted Pune to Ujjain darshan bus rental services, delivering comfort, safety, and a spiritually fulfilling travel experience.',

    top: 'Top Places to Visit in Mumbai with Sanavi Travels',


"topPlaces": [
  {
    "title": "Mahakaleshwar Jyotirlinga Temple",
    "description": "Mahakaleshwar Temple is one of the twelve Jyotirlingas of Lord Shiva and the most sacred site in Ujjain. Famous for the unique Bhasma Aarti performed at dawn, the temple attracts devotees from across India. Located on the banks of the Shipra River, it is a powerful center of spirituality and devotion."
  },
  {
    "title": "Ram Ghat",
    "description": "Ram Ghat is the most important ghat on the Shipra River, known for its religious significance and evening aarti rituals. It becomes especially vibrant during the Kumbh Mela, when millions of pilgrims gather for holy dips. The peaceful riverfront offers a deeply spiritual experience."
  },
  {
    "title": "Kal Bhairav Temple",
    "description": "Kal Bhairav Temple is a unique and ancient shrine where liquor is offered to the deity as part of ritual worship. Dedicated to Kal Bhairav, a fierce form of Lord Shiva, the temple is believed to protect Ujjain and fulfills devotees’ wishes."
  },
  {
    "title": "Harsiddhi Temple",
    "description": "Harsiddhi Temple is one of the Shakti Peethas and an important center of Goddess worship. The temple is famous for its towering oil lamps that are lit during festivals, creating a mesmerizing sight. It holds immense religious importance in Ujjain."
  },
  {
    "title": "Vedh Shala (Jantar Mantar)",
    "description": "Vedh Shala, built by Maharaja Jai Singh II, is an ancient astronomical observatory used to study celestial movements. It reflects India’s advanced knowledge of astronomy and science and remains a fascinating attraction for history and science enthusiasts."
  },
  {
    "title": "Chintaman Ganesh Temple",
    "description": "Chintaman Ganesh Temple is one of the oldest Ganesh temples in India, believed to relieve devotees of worries and obstacles. The idol is considered self-manifested and holds great spiritual significance among pilgrims."
  },
  {
    "title": "Bade Ganeshji Ka Mandir",
    "description": "Located near the Mahakaleshwar Temple, Bade Ganeshji Ka Mandir houses a massive idol of Lord Ganesha. It is a popular stop for devotees visiting Ujjain and adds to the city’s religious charm."
  },
  {
    "title": "Sandipani Ashram",
    "description": "Sandipani Ashram is believed to be the place where Lord Krishna, Sudama, and Balram studied under Guru Sandipani. The ashram features ancient structures, sacred water tanks, and spiritual teachings, making it a significant pilgrimage site."
  },
  {
    "title": "Gopal Mandir",
    "description": "Gopal Mandir is a beautifully built temple dedicated to Lord Krishna, constructed during the Maratha era. The temple’s silver-plated doors and serene atmosphere attract both devotees and architecture lovers."
  },
  {
    "title": "Shipra River Ghats",
    "description": "The ghats along the Shipra River form the spiritual backbone of Ujjain. Pilgrims gather here for holy baths, prayers, and evening aartis, especially during religious festivals. The riverfront offers tranquility and a deep connection to ancient traditions."
  }
]
,



"services": [
  {
    "name": "Pune to Ujjain Darshan Bus On Rent",
    "description": "Pune to Ujjain Darshan Bus On Rent offers comfortable and reliable bus services for devotees traveling to Ujjain for Mahakal and temple दर्शन. The buses are fully air-conditioned, spacious, and equipped with comfortable seating and ample luggage space for long-distance travel. Professional chauffeurs ensure safe highway driving, smooth routing, and timely arrivals. Ideal for families, religious groups, and pilgrimage tours, this service supports flexible travel plans, multiple temple visits, and stress-free spiritual journeys from Pune to Ujjain."
  },
  {
    "name": "Ujjain Bus Hire from Pune",
    "description": "Ujjain Bus Hire from Pune provides organized and dependable bus rental solutions for religious tours and long-distance travel. Well-maintained buses with air-conditioning, comfortable seats, and clean interiors ensure a pleasant journey. Experienced drivers handle traffic, highways, and route planning efficiently, making the trip safe and smooth. Suitable for families, senior citizens, and group pilgrims, this service allows flexible pickup points and customized darshan itineraries."
  },
  {
    "name": "AC Bus Pune to Ujjain",
    "description": "AC Bus Pune to Ujjain ensures a cool, relaxed, and comfortable journey during long hours of pilgrimage travel. Fully air-conditioned buses with spacious seating, good suspension, and sufficient legroom reduce travel fatigue. Professional chauffeurs focus on safe driving and timely scheduling. This service is ideal for families, religious groups, and tourists seeking comfort, safety, and convenience while traveling from Pune to Ujjain."
  },
  {
    "name": "Luxury Bus Ujjain Darshan",
    "description": "Luxury Bus Ujjain Darshan offers a premium travel experience with high-end buses featuring elegant interiors, plush seating, air-conditioning, and enhanced ride comfort. Designed for devotees who prefer a refined journey, this service is perfect for VIP pilgrims, senior citizens, and corporate religious groups. Professional chauffeurs ensure punctual travel, smooth driving, and well-planned routes for a peaceful darshan experience."
  },
  {
    "name": "Mahakal Darshan Bus Pune",
    "description": "Mahakal Darshan Bus Pune specializes in dedicated bus services for Shri Mahakaleshwar Jyotirlinga darshan. Spacious, air-conditioned buses with comfortable seating ensure a relaxed pilgrimage journey. Experienced drivers are familiar with religious routes, temple schedules, and travel coordination. Ideal for families, groups, and spiritual tours, this service focuses on safety, punctuality, and devotion-focused travel."
  },
  {
    "name": "Religious Tour Bus Pune",
    "description": "Religious Tour Bus Pune provides organized bus transport for temple tours, pilgrimages, and spiritual journeys across destinations like Ujjain. Well-maintained buses with air-conditioning and comfortable interiors ensure a smooth and peaceful journey. Professional chauffeurs handle long-distance travel efficiently, making it suitable for senior citizens, families, and religious groups seeking a reliable and serene travel experience."
  },
  {
    "name": "Family Ujjain Bus Trip",
    "description": "Family Ujjain Bus Trip is designed for families traveling together for darshan and temple visits. Spacious buses with air-conditioning, comfortable seating, and luggage space accommodate all family members conveniently. Experienced drivers ensure safe driving, smooth routes, and timely arrivals. This service allows families to travel together comfortably while focusing on devotion and quality time."
  },
  {
    "name": "Group Travel Ujjain Bus",
    "description": "Group Travel Ujjain Bus offers efficient and coordinated transport for large religious groups, societies, and pilgrimage tours. Air-conditioned buses with spacious seating and ample luggage capacity ensure comfort for all passengers. Professional chauffeurs manage group schedules, multiple stops, and long-distance routes smoothly, making this service ideal for organized temple tours from Pune to Ujjain."
  },
  {
    "name": "Affordable Ujjain Bus Hire",
    "description": "Affordable Ujjain Bus Hire provides budget-friendly bus rental options without compromising safety or comfort. Clean, air-conditioned buses with professional drivers ensure a smooth pilgrimage journey at economical pricing. Suitable for families, senior citizens, and group travelers, this service balances affordability, reliability, and convenience for Pune to Ujjain religious travel."
  },
  {
    "name": "Chauffeur Driven Ujjain Bus",
    "description": "Chauffeur Driven Ujjain Bus ensures a stress-free pilgrimage experience with professional drivers handling navigation, traffic, and highway conditions. Spacious, air-conditioned buses allow passengers to relax throughout the journey. Ideal for families, religious groups, and elderly travelers, this service emphasizes safety, punctuality, and comfort during long-distance temple tours."
  },
  {
    "name": "Best Ujjain Bus Service Pune",
    "description": "Best Ujjain Bus Service Pune delivers high-quality and dependable bus transportation for religious and pilgrimage travel. Well-maintained buses with air-conditioning, comfortable seating, and experienced chauffeurs ensure a safe and pleasant journey. Ideal for Mahakal darshan, family trips, and group pilgrimages, this service focuses on customer satisfaction, reliability, and smooth long-distance travel."
  },
  {
    "name": "Pune Ujjain Travel Bus",
    "description": "Pune Ujjain Travel Bus provides dedicated bus services for devotees and tourists traveling between Pune and Ujjain. Air-conditioned buses with spacious interiors and professional drivers ensure comfortable and timely travel. Flexible travel plans, multiple pickup points, and reliable scheduling make this service suitable for religious tours, family trips, and group journeys."
  },
  {
    "name": "Pilgrimage Bus Rental Pune",
    "description": "Pilgrimage Bus Rental Pune offers specialized bus rental solutions for temple tours, religious events, and spiritual journeys. Fully air-conditioned buses with comfortable seating and trained drivers ensure a peaceful and organized travel experience. Suitable for Mahakal darshan, group pilgrimages, and family temple visits, this service emphasizes safety, devotion, and convenience."
  },
  {
    "name": "Temple Tour Bus Pune",
    "description": "Temple Tour Bus Pune provides organized transportation for multi-temple visits, religious circuits, and spiritual tours including Ujjain. Spacious, air-conditioned buses with professional chauffeurs ensure smooth travel across long distances. Ideal for families, senior citizens, and group devotees, this service supports customized routes and flexible schedules for temple darshan."
  },
  {
    "name": "Online Bus Booking Pune",
    "description": "Online Bus Booking Pune allows easy and convenient reservation of buses for Pune to Ujjain darshan travel. Customers can select bus type, travel dates, pickup locations, and trip preferences with quick confirmation. Fully air-conditioned buses with experienced chauffeurs ensure safe, reliable, and comfortable pilgrimage travel planning."
  }
],
"tableData": [
  ["Pune to Ujjain Darshan Bus On Rent", "Ujjain Bus Hire from Pune"],
  ["AC Bus Pune to Ujjain", "Luxury Bus Ujjain Darshan"],
  ["Mahakal Darshan Bus Pune", "Religious Tour Bus Pune"],
  ["Family Ujjain Bus Trip", "Group Travel Ujjain Bus"],
  ["Affordable Ujjain Bus Hire", "Chauffeur Driven Ujjain Bus"],
  ["Best Ujjain Bus Service Pune", "Pune Ujjain Travel Bus"],
  ["Pilgrimage Bus Rental Pune", "Temple Tour Bus Pune"],
  ["Online Bus Booking Pune", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Pune to Ujjain Darshan Bus On Rent with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers comfortable and reliable Pune to Ujjain darshan bus on rent services, perfect for religious trips, group tours, family travel, and spiritual journeys."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Buses",
    "WhyChoosedescription": "Travel in air-conditioned, clean, and regularly serviced buses for a smooth and enjoyable journey from Pune to Ujjain."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed drivers are courteous, professional, and familiar with the Pune to Ujjain route, ensuring safe and timely travel for your darshan trip."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for Pune to Ujjain darshan bus rentals, including fuel, tolls, and driver allowances, with no hidden fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, itinerary planning, and any travel queries during your Pune to Ujjain trip."
  },
  {
    "WhyChooseheading": "Flexible Rental Options",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized bus rental packages based on your Pune to Ujjain darshan travel requirements."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before each trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for Pune to Ujjain darshan bus on rent services."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide Pune to Ujjain darshan bus on rent?',
    answer: 'Yes, Sanavi Travels offers comfortable and reliable Pune to Ujjain darshan bus rental services for religious trips and group tours.'
  },
  {
    question: 'How can I book a Pune to Ujjain darshan bus?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What type of buses are used for the Pune to Ujjain trip?',
    answer: 'Sanavi Travels provides air-conditioned and well-maintained buses suitable for long-distance travel from Pune to Ujjain.'
  },
  {
    question: 'Are drivers experienced on the Pune to Ujjain route?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with the long-distance Pune to Ujjain route.'
  },
  {
    question: 'Can I customize my Pune to Ujjain bus trip?',
    answer: 'Absolutely. You can select preferred stops, routes, and travel schedules based on your trip requirements.'
  },
  {
    question: 'Is the bus service available 24x7?',
    answer: 'Yes, Sanavi Travels offers support and assistance throughout your Pune to Ujjain darshan journey.'
  },
  {
    question: 'Are the buses sanitized before the trip?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized before departure.'
  },
  {
    question: 'What payment options are available for Pune to Ujjain bus rentals?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the rest of the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Pune to Ujjain darshan trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Manoj Sharma',
    feedback: 'Booked a Pune to Ujjain darshan bus with Sanavi Travels. Comfortable ride and excellent service throughout the journey.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Ritu Verma',
    feedback: 'Fantastic experience! The bus was clean, the driver was professional, and we reached Ujjain on time for our darshan.',
    rating: 5
  }
];






































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Ujjain Darshan Bus On Rent - Sanavi Travels",
  "description": "Book buses from Pune to Ujjain for Mahakal and Ujjain Darshan with Sanavi Travels. AC and luxury buses ideal for family trips, group travel, religious tours, pilgrimage trips, and chauffeur-driven comfortable journeys.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1600"
  }
};





  return (
    <div>
<Helmet>
  <title>
    Pune to Ujjain Darshan Bus On Rent | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Hire AC and luxury buses from Pune to Ujjain with Sanavi Travels. Perfect for Mahakal Darshan, religious tours, family trips, group travel, pilgrimage tours, and safe chauffeur-driven journeys."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/84.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoujjaindarshanbusonrent;